import React from 'react'
import cn from 'classnames'

import style from './Container.module.css'

type ContainerPropType = {
    classes?: string
}

const Container: React.FC<ContainerPropType> = ({ children, classes }) => {
    return (
        <div className={cn(style.container, classes)}>
            {children}
        </div>
    )
}

export default Container
